__turbopack_context__.v({
  "templatesMobile": "FeaturedTemplatesMobile-module-scss-module__NAcHNW__templatesMobile",
});
